import { ActionType, createReducer } from 'typesafe-actions';

import * as actions from './actions';
import { modalInitialState } from './initialState';

type ModalState = typeof modalInitialState;
type ModalActions = ActionType<typeof actions>;

export const modalReducer = createReducer<ModalState, ModalActions>(modalInitialState)
  .handleAction(actions.actionShowModal, (state, action) => {
    if (state.contextModal.onReject) state.contextModal.onReject();

    return {
      ...state,
      isModalOpen: true,
      contextModal: {
        ...state.contextModal,
        ...action.payload,
      },
    };
  })
  .handleAction(actions.actionSubmitModal, (state) => {
    if (state.contextModal.onResolve) state.contextModal.onResolve();

    return {
      ...state,
      isModalOpen: false,
      contextModal: modalInitialState.contextModal,
    };
  })
  .handleAction(actions.actionUpdateModal, (state, action) => ({
    ...state,
    contextModal: {
      ...state.contextModal,
      ...action.payload,
    },
  }))
  .handleAction(actions.actionCloseModal, (state) => {
    if (state.contextModal.onReject) state.contextModal.onReject();

    return {
      ...state,
      isModalOpen: false,
      contextModal: modalInitialState.contextModal,
    };
  });
